import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { LogOut, Wheat } from "lucide-react";
import { useApp } from "@/context/AppContext";

export default function Navbar() {
  const { logout } = useApp();
  const navigate = useNavigate();
  const location = useLocation();

  const doLogout = () => {
    logout();
    navigate("/login");
  };

  const linkCls = (active) =>
    `text-[14px] transition-colors ${active ? "font-semibold text-[#1b5e3f]" : "text-[#5c6b52] hover:text-[#1b5e3f]"}`;

  return (
    <nav className="no-print sticky top-0 z-50 border-b-2 border-[#E0A106]/40 bg-[#fbf9f2]/95 backdrop-blur">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-3">
        <button
          onClick={() => navigate("/apply")}
          className="flex items-center gap-2.5"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-[#1b5e3f] text-white shadow-sm">
            <Wheat className="h-5 w-5" strokeWidth={2} />
          </span>
          <span className="text-[19px] font-bold tracking-tight text-[#1b5e3f] font-latin">ASSK Sangli</span>
        </button>
        <div className="flex items-center gap-6">
          <a href="/assk-arj-namuna.pdf" target="_blank" rel="noopener noreferrer" data-testid="nav-arj-namuna" className={linkCls(false)}>
            अर्जाचा नमूना
          </a>
          <button onClick={() => navigate("/apply")} className={linkCls(location.pathname === "/apply")}>
            Application form
          </button>
          <button onClick={doLogout} className="flex items-center gap-1 rounded-full border border-[#1b5e3f]/25 px-3 py-1.5 text-[13px] font-medium text-[#5c6b52] transition-colors hover:border-[#dc2626] hover:text-[#dc2626]">
            <LogOut className="h-4 w-4" /> Logout
          </button>
        </div>
      </div>
    </nav>
  );
}
